<template>
    <div class="calendarEmployer">
        <div class="o-main-content-area">
            <button style="padding:10px" @click="prev()">&lt;</button>
            <button style="padding:10px" @click="next()">&gt;</button>
            <div class="c-responsive-fixwidth">
                <full-calendar ref="calendar" :config="config" :events="events" :header="header" :defaultView="defaultView" @event-selected="eventSelected"></full-calendar>
            </div>


            <modal name="calender-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
                <div tabindex="-1" role="dialog">
                    <div role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button @click="closeCalenderDetals()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 class="modal-title">{{this.modal_event.title}}</h1>
                            </div>
                            <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender">
                                <form>

                                <div class="row">
                                    <div class="col-sm-12 o-no-padding o-calender-container">

                                        <div class="col-md-5 o-right-no-padding o-calender-area">
                                            <div class="o-calls-table">
                                                <div class="o-calender-details-list">
                                                    <ul class="">
                                                        <li><strong>Job No.</strong> <span>#{{this.modal_event.job_number}}</span></li>
                                                        <li><strong>Dispatched by:</strong> <span>{{this.modal_event.created_by}}</span></li>
                                                        <li><strong>Start Date:</strong> <span>{{getDate(this.modal_event.start)}}</span></li>
                                                        <li><strong>End Date:</strong> <span>{{getDate(this.modal_event.job_end)}}</span></li>
                                                        <li><strong>Employer:</strong> <span>{{this.modal_event.hiring_organization}}</span></li>
                                                        <li><strong>Payroll:</strong> <span>{{this.modal_event.payroll}}</span></li>
                                                        <li ><strong>Employer Request:</strong> <span>{{this.modal_event.employer_requests}}</span></li>
                                                        <li><strong>Comment:</strong> <span>{{this.modal_event.comment}}</span></li>
                                                    </ul>
                                                </div>
                                                <!-- <div class="o-calender-wishlist">
                                                    <a @click="viewCalendarCall(modal_event.id)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-yellow">View calls</a>
                                                </div> -->
                                                
                                            </div>
                                        </div>
                                        <div class="col-md-7 o-calender-area">
                                            
                                            <div class="custom-row u-common-box-shadow c-radius3">
                                                <div class="o-calls-table">
                                                    <div class="o-common-head">
                                                        <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> Venue: {{modal_event.venue && modal_event.venue.addresses ?modal_event.venue.name+', '
                                                        +modal_event.venue.addresses[0].address+', '
                                                        +modal_event.venue.addresses[0].municipality+', '
                                                        +modal_event.venue.addresses[0].state_province+', '+modal_event.venue.addresses[0].postcode+', '
                                                        +modal_event.venue.addresses[0].country :''}}</h5>
                                                    </div>
                                                    <div class="o-map-conatiner">
                                                        <iframe 
                                                            width="100%"
                                                            height="100%"
                                                            frameborder="0" style="border:0"
                                                            :src="getMapUrl()" allowfullscreen>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    </div>

                                </form>
                            </div>

                            <div class="modal-footer text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <button type="button" @click="goToCalls(modal_event.id)" class="btn c-solid-btn c-solid-btn--large c-solid-btn--orange" ><i class="fa fa-eye" aria-hidden="true"></i> View Calls</button>
                                    </li>
                                    <li>
                                        <button @click="closeCalenderDetals()" type="button" class="btn c-common-btn c-common-btn--large c-solid-btn--red" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                                    </li>
                                    <li v-if="wishlist_lock">
                                        <button type="button" @click="scheduleWishlist()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--orange" ><i class="fa fa-star" aria-hidden="true"></i> Wishlist</button>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <!-- /.modal-content -->
                    </div>
                        <!-- /.modal-dialog -->
                </div>
            </modal>

        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        data() {
            return {
                employer_job_client_id: null,
                events: [],
                wishlist_lock:false,
                defaultView: ['month'],
                header: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                now: new Date(),
                month: 0,
                year: 0,
                modal_event: [],
                full_address_map:"",
                hide_empty_days : 0,
                config: {
                    eventLimit: true, // for all non-agenda views
                    views: {
                        agenda: {
                            eventLimit: 6 // adjust to 6 only for agendaWeek/agendaDay
                        }
                    }

                },
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                companyId: 'companyId',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
            })
        },
        created() {
            this.month = this.now.getMonth() + 1;
            this.year = this.now.getFullYear();
            service.get('employerjob/calendarJobs', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'employer-id': this.companyId,
                'month': this.month,
                'year': this.year
            }).
            then((res) => {
                //console.log("Calender",res);
                var jobs = res.data.result;
                for (var i = 0; i < jobs.length; i++) {
                    var start = jobs[i].start.split(" ");
                    var end = jobs[i].end.split(" ");
                    end[0] = moment(end[0],'YYYY-MM-DD').add(1, "d").format("YYYY-MM-DD").toString();
                    console.log(start,end);
                    if(this.hide_empty_days == 1)
                    {
                      if(jobs[i].calls_count.length != 0)
                      {
                        let event = {
                            'start': start[0],
                            'end': end[0],
                            'job_end': end[0],
                            'title': jobs[i].title,
                            'id': jobs[i].id,
                            'color': "#" + jobs[i].link_color,
                            'job_number': jobs[i].job_number,
                            'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                            'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : 'NA',
                            'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : 'NA',
                            'venue': jobs[i].venue,
                            'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                            'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                            'notes':jobs[i].notes,
                            'employer_requests': jobs[i].employer_requests,
                            'comment':jobs[i].comment,
                            'status':jobs[i].status.name,
                            'employer_requests_private':jobs[i].employer_requests_private,
                            'comment_private':jobs[i].comment_private,
                            'client_id': jobs[i].client_id
                        }
                        this.events.push(event);
                      }
                    }
                    else {
                        let event = {
                            'start': start[0],
                            'end': end[0],
                            'job_end': end[0],
                            'title': jobs[i].title,
                            'id': jobs[i].id,
                            'color': "#" + jobs[i].link_color,
                            'job_number': jobs[i].job_number,
                            'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                            'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : 'NA',
                            'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : 'NA',
                            'venue': jobs[i].venue,
                            'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                            'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                            'notes':jobs[i].notes,
                            'employer_requests': jobs[i].employer_requests,
                            'comment':jobs[i].comment,
                            'status':jobs[i].status.name,
                            'employer_requests_private':jobs[i].employer_requests_private,
                            'comment_private':jobs[i].comment_private,
                            'client_id': jobs[i].client_id
                        };
                        this.events.push(event);
                    }

                }
            }).catch((err) => {
                console.log(err);
            });
        },
        methods: {
            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},
            goToCalls(id){
                this.closeCalenderDetals();
                this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: '/calendarJobCall/'+btoa(id)+'?client='+btoa(this.modal_event.client_id)
                });
                // console.log('calendarJobCall'+btoa(id)+'?client='+btoa(this.modal_event.client_id));
                // this.$router.push({
                //     path: `/viewCallsEmployer/`+ btoa(id)
                // });
            },
            getDate(date){
               return moment(date).format('DD MMM YYYY');
            },
            viewCalendarCall(id){
                console.log(this.modal_event.client_id)
                this.$modal.hide("calender-details");
                console.log('calendarJobCall'+btoa(id)+'?client='+btoa(this.modal_event.client_id));
                // this.$router.push({
                //     path: '/calendarJobCall/'+btoa(id)+'?client='+btoa(this.modal_event.client_id)
                // });
            },
            closeCalenderDetals() {
                this.$modal.hide("calender-details");
            },
            scheduleWishlist() {
                this.$store.dispatch('setWishListType', 'calendar');
                this.$router.push({
                    path: `/wishlist/`+btoa(this.employeeId)
                });
            },
            next() {
                var current = new Date(this.now.getFullYear(), this.now.getMonth() + 1, 1);
                this.now = current;
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.events = [];
                service.get('employerjob/calendarJobs', {
	                'Authorization': this.userToken,
	                'cs3-context-role': this.userRole,
	                'employer-id': this.companyId,
	                'month': this.month,
	                'year': this.year
	            }).
                then((res) => {
                    var jobs = res.data.result;
                    var cal = this.$refs.calendar;
                    //console.log(cal);
                    for (var i = 0; i < jobs.length; i++) {
                        var start = jobs[i].start.split(" "); 
                        var end = jobs[i].end.split(" ");
                        if(this.hide_empty_days == 1)
                        {
                          if(jobs[i].calls_count.length != 0)
                          {
                            let event = {
                                'start': start[0],
                                'end': end[0],
                                'job_end': end[0],
                                'title': jobs[i].title,
                                'id': jobs[i].id,
                                'color': "#" + jobs[i].link_color,
                                'job_number': jobs[i].job_number,
                                'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                                'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : '-',
                                'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : '-',
                                'venue': jobs[i].venue,
                                'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                                'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                                'notes':jobs[i].notes,
                                'employer_requests': jobs[i].employer_requests,
                                'comment':jobs[i].comment,
                                'status':jobs[i].status.name,
                                'employer_requests_private':jobs[i].employer_requests_private,
                                'comment_private':jobs[i].comment_private,
                                'client_id': jobs[i].client_id
                            }
                            this.events.push(event);
                          }
                        }
                        else {
                            let event ={
                                'start': start[0],
                                'end': end[0],
                                'job_end': end[0],
                                'title': jobs[i].title,
                                'id': jobs[i].id,
                                'color': "#" + jobs[i].link_color,
                                'job_number': jobs[i].job_number,
                                'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                                'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : '-',
                                'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : '-',
                                'venue': jobs[i].venue,
                                'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                                'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                                'notes':jobs[i].notes,
                                'employer_requests': jobs[i].employer_requests,
                                'comment':jobs[i].comment,
                                'status':jobs[i].status.name,
                                'employer_requests_private':jobs[i].employer_requests_private,
                                'comment_private':jobs[i].comment_private,
                                'client_id': jobs[i].client_id
                            }
                            this.events.push(event);

                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
                this.$refs.calendar.fireMethod('next')
            },
            prev() {
                var current = new Date(this.now.getFullYear(), this.now.getMonth() - 1, 1);
                this.now = current;
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.events = [];
                service.get('employerjob/calendarJobs', {
	                'Authorization': this.userToken,
	                'cs3-context-role': this.userRole,
	                'employer-id': this.companyId,
	                'month': this.month,
	                'year': this.year
	            }).
                then((res) => {

                    var jobs = res.data.result;
                    var cal = this.$refs.calendar;
                   //console.log(jobs);
                    for (var i = 0; i < jobs.length; i++) {
                        var start = jobs[i].start.split(" ");
                        var end = jobs[i].end.split(" ");
                        if(this.hide_empty_days == 1)
                        {
                          if(jobs[i].calls_count.length != 0)
                          {
                            this.events.push({
                                'start': start[0],
                                'end': end[0],
                                'job_end': end[0],
                                'title': jobs[i].title,
                                'id': jobs[i].id,
                                'color': "#" + jobs[i].link_color,
                                'job_number': jobs[i].job_number,
                                'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                                'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : '-',
                                'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : '-',
                                'venue': jobs[i].venue,
                                'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                                'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                                'notes':jobs[i].notes,
                                'client_id': jobs[i].client_id
                            });
                          }
                        }
                        else {
                            this.events.push({
                                'start': start[0],
                                'end': end[0],
                                'job_end': end[0],
                                'title': jobs[i].title,
                                'id': jobs[i].id,
                                'color': "#" + jobs[i].link_color,
                                'job_number': jobs[i].job_number,
                                'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                                'hiring_organization': (jobs[i].hiring_organization) ? jobs[i].hiring_organization.name : '-',
                                'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : '-',
                                'venue': jobs[i].venue,
                                'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                                'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                                'notes':jobs[i].notes,
                                'client_id': jobs[i].client_id
                            });
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
                this.$refs.calendar.fireMethod('prev')
            },
            eventSelected(event, jsEvent, view) {    
                this.modal_event = event;
                console.log('client: ', this.modal_event.client_id);
                // console.log('calander details',this.modal_event);
                this.employer_job_client_id = this.modal_event.client_id;
                let venue = event.venue;
                if(venue && venue.addresses && venue.addresses.length){
                    this.full_address_map =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
                }
                this.$modal.show("calender-details");

                //alert('selected');
                // this.$store.dispatch('setJob', {id:event.id});
                // this.$router.push({
                //     path: `/jobDetails`
                // });

            },
        }

    }

</script>
<style>
    @import 'fullcalendar/dist/fullcalendar.css';

</style>



// WEBPACK FOOTER //
// src/components/calendar/calendarEmployer.vue